export const parseFloat = (value: string): number => Number.parseFloat(value);

export const parsePercentage = (value: string): number => {
  const percentage = Number.parseInt(value, 10);
  if (percentage < 0) return 0;
  if (percentage > 100) return 100;
  return percentage;
};
